module.exports = __webpack_public_path__ + "img/info-yellow-icon.9984db6b.svg";